import { z } from 'zod';

import { SourcePreparationTerminalReasonCodeSchema } from '../../source-preparation/source-preparation-types.js';
import { IsoDateTimeSchema } from '../../shipments/shipments-types.js';
import type {
  SourcePreparationRequestStatusUpdatedEventPayload,
} from './source-preparation-sync.dto.js';

export const SourcePreparationRequestStatusUpdatedEventPayloadSchema: z.ZodType<SourcePreparationRequestStatusUpdatedEventPayload> =
  z
    .object({
      schemaVersion: z.literal(1),
      eventId: z.uuid(),
      occurredAt: IsoDateTimeSchema,
      companyId: z.uuid(),
      stationId: z.uuid(),
      requestId: z.uuid(),
      targetOutboundType: z.literal('SHIPMENT'),
      status: z.enum(['CANCELED', 'INVALIDATED']),
      reasonCode: SourcePreparationTerminalReasonCodeSchema,
    })
    .strict();
